import { mutationOptions } from "@/common/mutations/mutationOptions";
import type { QueryClient } from "@tanstack/react-query";
import { buildPushNotificationsPermissionsQueryKey } from "./buildPushNotificationsPermissionsQuery";

const pushNotificationsModule =
	import.meta.env.VITE_CAPACITOR_BUILD === "true"
		? import("@capacitor/push-notifications")
		: null;

export function buildPushNotificationsRequestPermissionsMutation(
	queryClient: QueryClient,
) {
	return mutationOptions({
		mutationKey: ["capacitor-push-notifications-request-permissions"],
		mutationFn: () =>
			pushNotificationsModule
				? pushNotificationsModule.then((m) =>
						m.PushNotifications.requestPermissions(),
					)
				: Promise.reject(new Error("Push notifications are not supported")),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: buildPushNotificationsPermissionsQueryKey(),
			});
		},
	});
}
